import Chatbox from '@assets/icons/chatbox.svg'
import { Icon } from './Icon'

export const ChatboxIcon = Icon(Chatbox)
